/* tslint:disable */
/* eslint-disable */
/**
 * MinSide.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ApplicationStatus {
    Active = 'Active',
    Inactive = 'Inactive'
}


export function instanceOfApplicationStatus(value: any): boolean {
    for (const key in ApplicationStatus) {
        if (Object.prototype.hasOwnProperty.call(ApplicationStatus, key)) {
            if (ApplicationStatus[key as keyof typeof ApplicationStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ApplicationStatusFromJSON(json: any): ApplicationStatus {
    return ApplicationStatusFromJSONTyped(json, false);
}

export function ApplicationStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApplicationStatus {
    return json as ApplicationStatus;
}

export function ApplicationStatusToJSON(value?: ApplicationStatus | null): any {
    return value as any;
}

export function ApplicationStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): ApplicationStatus {
    return value as ApplicationStatus;
}

